const TableMaker = ({ json, isHidden }) => {
    let rank, isBuildnewRank, credits, scopeOfFiveCourse, data, isBuildCreditCount, isBuildNewRank
    return (<table hidden={isHidden}   aria-hidden={isHidden} id='htmltable' border={1} className='table'>
        <thead>
            <tr border={1} className='bg-primary'>
                <th className='text-white'>Couse Code and Description</th>
                <th className='text-white'>Credits</th>
                <th className='text-white'>Prerequisite(s)</th>
                <th className='text-white'>Status</th>
            </tr>
        </thead>
        <tbody>
            {json?.map((element, index) => {
                if (element.rank != rank && element.rank != '' && element.rank) {
                    rank = element.rank
                    isBuildNewRank = true
                    credits = 0
                    scopeOfFiveCourse = 0
                } else {
                    isBuildNewRank = false
                    scopeOfFiveCourse++
                }
                // if (!data[index + 1]) {
                //     // isBuildCreditCount = true
                // } else {
                //     if (data[index + 1].rank != data[index].rank && (data?.[index + 1]?.rank ?? '') != '') {
                //         isBuildCreditCount = true
                //     } else {
                //         isBuildCreditCount = false
                //     }
                // }
                // credits += course.course.credit

                return <RecordTableMaker key={`RecordTableMaker-${index}`} isBuildNewRank={isBuildNewRank} element={element} index={index}  />;
            })}
        </tbody>
    </table>)
}

export default TableMaker

const RecordTableMaker = ({ isBuildNewRank, element, index }) => {
    return (
        <>
            {isBuildNewRank && (
                <tr>
                    <td className='bg-warning fw-bold'>{element.rank} Semester</td>
                    <td className='bg-warning'> </td>
                    <td className='bg-warning'></td>
                    <td className='bg-warning'></td>
                </tr>
            )}
            <tr key={`TableMaker-${index}-body`}>
                <td>{element?.element?.code} {element?.name}</td>
                <td>{element?.credit}</td>
                <td>{element?.preRequisite}</td>
                <td>{element.coursestatus} </td>
            </tr>
        </>
    )
}
